/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"], a = ["Janvier", "F\xE9vrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Ao\xFBt", "Septembre", "Octobre", "Novembre", "D\xE9cembre"], n = "Ann\xE9es", r = "Ann\xE9e", t = "Mois", d = "Semaine", s = "Jour", i = "Aujourd'hui", o = "Aucun \xE9v\xE9nement", u = "Jour entier", m = "Supprimer", v = "Cr\xE9er un \xE9v\xE9nement", M = "dddd D MMMM YYYY", y = { weekDays: e, months: a, years: "Ann\xE9es", year: "Ann\xE9e", month: "Mois", week: "Semaine", day: "Jour", today: "Aujourd'hui", noEvent: "Aucun \xE9v\xE9nement", allDay: "Jour entier", deleteEvent: "Supprimer", createEvent: "Cr\xE9er un \xE9v\xE9nement", dateFormat: "dddd D MMMM YYYY" };
export {
  u as allDay,
  v as createEvent,
  M as dateFormat,
  s as day,
  y as default,
  m as deleteEvent,
  t as month,
  a as months,
  o as noEvent,
  i as today,
  d as week,
  e as weekDays,
  r as year,
  n as years
};
